export const IdentityVerificationStatus = {
    Requested: 'Requested',
    Started: 'Started',
    Submitted: 'Submitted',
    Verified: 'Verified',
    Cancelled: 'Cancelled',
    Failed: 'Failed',
    Retry: 'Retry',
} as const

export type IdentityVerificationStatusTypes =
    (typeof IdentityVerificationStatus)[keyof typeof IdentityVerificationStatus]

export interface IdentityVerification {
    id: number
    accountantId: number
    userId: number
    status: keyof typeof IdentityVerificationStatus
    submittedDateUTC: string | null
    approvedDateUTC: string | null
    notes: string
}
